import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ILocation } from './ILocation';

@Injectable({
  providedIn: 'root'
})
export class CountryAreaLookupService {
  constructor(@Inject(HttpClient) private http: HttpClient
    , @Inject(LoggingService) private log: LoggingService) {
  }
  uri = `${environment.apiLocation}/CountryArea`;

  public get (type: number): Observable<Array<ILocation>> {
    this.log.verbose({ type: 'CountryAreaLookupService:get', uri: `${this.uri}/${type}` });
    return this.http.get<Array<ILocation>>(`${this.uri}/${type}`)
      .pipe(
        tap(res => this.log.verbose({ type: 'CountryAreaLookupService:reponse', res }))
      )
      ;
  }

  public getLocations (type: number, countryArea: string): Observable<Array<ILocation>> {
    this.log.verbose({ type: 'CountryAreaLookupService:get', uri: `${this.uri}/${type}/${countryArea}` });
    return this.http.get<Array<ILocation>>(`${this.uri}/${type}/${countryArea}`)
      .pipe(
        tap(res => this.log.verbose({ type: 'CountryAreaLookupService:reponse', res }))
      )
      ;
  }
}
